// src/icons/svgs/chevron.svg
import * as React from "react";
import { forwardRef } from "react";
import { jsx } from "react/jsx-runtime";
var SvgChevron = (props, ref) => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ref, ...props, children: /* @__PURE__ */ jsx("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5, d: "m18 15-6-6-6 6" }) });
var ForwardRef = forwardRef(SvgChevron);
var chevron_default = ForwardRef;
export {
  chevron_default as Chevron
};
